'use client';

import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

/** Legal copy shown in the modal (French only per policy). */
function LegalMentionsContent() {
  return (
    <div className="mention-legal-container">
      <h1 id="legal-mentions-title" className="mention-legal-title">
        MENTIONS LÉGALES
      </h1>
      <ol className="mention-legal-list">
        <li>
          <h2 className="mention-legal-section-title">ÉDITION</h2>
          <p>
            Ce site est édité par Deep Block SAS, SIRET : 829 773 670, dont le siège social est
            situé au 69 Place du Docteur Félix Lobligeois 75017 Paris (France).
          </p>
          <p>Le présent site est hébergé par SIO.</p>
          <p>Directeur de la publication : Christophe LEMÉE (CEO)</p>
          <p>
            Toute question, demande ou réclamation peut être adressée à l’adresse suivante :{' '}
            <a href="mailto:contact@deepblock.eu" className="mention-legal-link">
              contact@deepblock.eu
            </a>
          </p>
          <p>Deep Block SAS est soumise aux lois en vigueur sur le territoire français.</p>
          <p>
            La plateforme des services SaaS en ligne dédiée à la gestion de la Signature
            Electronique « Simple, Avancée et Qualifiée » au sein de la définition eIDAS pour les
            entreprises.
          </p>
        </li>
        <li>
          <h2 className="mention-legal-section-title">HÉBERGEMENT</h2>
          <p>
            Les serveurs de la plateforme sont eux géographiquement localisés en France (Orléans et
            Vélizy pour le site du PCA).
          </p>
          <p>Pour plus d’informations sur le stockage des données, veuillez-nous contacter.</p>
        </li>
        <li>
          <h2 className="mention-legal-section-title">CNIL</h2>
          <p>
            Conformément à la loi Informatique et Liberté 78-17 du 6 janvier 1978 modifiée, vous
            disposez d’un droit d’opposition (art. 38), d’accès (art. 39), de rectification (art.
            40) des données qui vous concernent.
          </p>
          <p>Envoyez-nous vos demandes :</p>
          <p>
            par voie postale : Deep Block (VitalSign), 69 Place du Docteur Félix Lobligeois 75017
            Paris
          </p>
          <p>par voie électronique : Nous contacter (à l&apos;aide du formulaire)</p>
          <p>
            Deep Block respecte la plus grande confidentialité, en particulier des messages transmis
            par voie électronique.
          </p>
          <p>
            Nous utilisons des cookies afin d’assurer le bon déroulement de votre visite et de
            réaliser des statistiques d’audience.
          </p>
        </li>
        <li>
          <h2 className="mention-legal-section-title">PROPRIÉTÉ INTELLECTUELLE</h2>
          <p>
            Les icônes et illustrations utilisées sur ce site web sont issus du service FOTOLIA,
            SIO et de l&apos;entreprise Deep Block.
          </p>
          <p>
            L’ensemble de ce site relève de la législation française et internationale sur le droit
            d’auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés,
            y compris pour les documents téléchargeables et les représentations iconographiques et
            photographiques. Les visuels d’illustration de ce site sont propriété de l’Éditeur. Les
            droits d’utilisation, de reproduction et de diffusion sont strictement réservés à la
            communication de l’Éditeur. La reproduction de tout ou partie de ce site sur un support
            électronique ou papier quel qu’il soit est formellement interdite sauf autorisation
            expresse du responsable du site. Pour d’autres utilisations, veuillez contacter le
            responsable du site. Les marques citées sur ce site sont déposées par les sociétés qui en
            sont propriétaires.
          </p>
        </li>
        <li>
          <h2 className="mention-legal-section-title">
            POLITIQUE DE CONFIDENTIALITÉ ET TRAITEMENT DE DONNÉES
          </h2>
          <p>
            Dans le cadre de la plateforme, le Client confie à Deep Block la réalisation d’un
            certain nombre de traitements pour son compte.
          </p>
          <p>
            Sauf instructions contraires du Client, la Solution n’implique pas de transfert de
            données à caractère personnel en dehors du l’Union Européenne.
          </p>
          <p>
            Deep Block traite ces informations selon les instructions du Client, pour les
            finalités des traitements réalisés dans le cadre de l’utilisation de la plateforme.
          </p>
          <p>
            Deep Block ne pourra en aucun cas exploiter les données personnelles collectées et
            traitées pour ses propres besoins, en particulier les données des utilisateurs de la
            plateforme aux fins de prospection commerciale.
          </p>
          <p>
            Deep Block n’effectue aucun contrôle sur la conformité de la politique de
            confidentialité établie par le Client à l’attention de ses cocontractants et il
            appartient exclusivement au Client de s’acquitter de ses obligations d’information à
            l’égard des personnes concernées. Le Client garantit Deep Block contre tout recours au
            titre de ces obligations d’information.
          </p>
          <p>
            Si Deep Block considère qu’une instruction constitue une violation de la réglementation
            applicable susvisée, il en informe le Client ou, le cas échéant, le tiers revendeur du
            Service auprès du Client.
          </p>
          <p>
            Deep Block s’interdit de divulguer ou de permettre la divulgation des données à caractère
            personnel à des tiers, sauf convention contraire ou autorisation expresse du Client. Deep
            Block garantit la confidentialité des données à caractère personnel traitées et veille à
            ce que les personnes autorisées à traiter les données s’engagent à respecter la
            confidentialité ou soient soumises à un accord de confidentialité, et qu’elles ont la
            formation nécessaire en matière de protection des données.
          </p>
          <p>
            Deep Block est soumise à une obligation de transparence et de traçabilité des
            traitements qu’elle effectue pour le compte du Client sur les données personnelles des
            personnes physiques qui lui sont confiées ou dont Deep Block constitue des fichiers dans
            le cadre de l’exécution de la Licence et ses éventuelles suites.
          </p>
          <p>
            A la demande du Client, Deep Block fournira une liste exhaustive de l’ensemble de ses
            propres sous-traitants et tous destinataires de données dans le cadre de l’exécution de
            la Licence.
          </p>
          <p>
            Dans la mesure du possible, Deep Block aide le Client à s’acquitter de son obligation de
            donner suite aux demandes d’exercice des droits des personnes concernées : droit d’accès,
            de rectification, d’effacement et d’opposition, droit à la limitation du traitement, droit
            à la portabilité des données, droit de ne pas faire l’objet d’une décision individuelle
            automatisée (y compris le profilage).
          </p>
          <p>
            Deep Block adresse au Client sans délai toute demande qui serait formulée auprès de lui
            par une personne concernée par les traitements effectués comme sous-traitant du Client.
            Deep Block n’est pas chargée de répondre aux personnes concernées pour le compte du
            Client.
          </p>
          <p>
            Deep Block notifie au Client toute violation de données à caractère personnel dans un
            délai maximum de 24 heures après en avoir pris connaissance. Cette notification est
            accompagnée de toute documentation utile afin de permettre au Client, si nécessaire, de
            notifier cette violation à l’autorité de contrôle compétente ainsi qu’aux personnes
            concernées, le cas échéant et de prendre les mesures requises par la réglementation
            applicable. Deep Block n’est pas chargée de cette notification pour le compte du Client.
          </p>
          <p>
            Le Client garantit Deep Block contre toute action, de quelque nature qu’elle soit,
            pouvant être intentée contre Deep Block par une personne concernée ou encore tout tiers
            pour non-respect de la réglementation en matière de protection des données à caractère
            personnel imputable au Client au titre de ses obligations en tant que responsable de
            traitement, ou en raison d’un manquement aux conditions du Service , qui serait commis
            par le Client et/ou par ses éventuels autres sous-traitants et partenaires susceptibles
            d’intervenir dans le cadre du Service du fait du Client.
          </p>
        </li>
      </ol>
    </div>
  );
}

type LegalNoticesContextValue = { openLegalNotices: () => void };

const LegalNoticesContext = createContext<LegalNoticesContextValue | null>(null);

export function useLegalNotices(): LegalNoticesContextValue {
  const ctx = useContext(LegalNoticesContext);
  if (!ctx) {
    throw new Error('useLegalNotices must be used within LegalNoticesProvider');
  }
  return ctx;
}

export function LegalNoticesProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!open) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const openLegalNotices = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => setOpen(false), []);

  const modal =
    open && mounted ? (
      <div
        className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/45 p-3 sm:p-4"
        role="presentation"
        onClick={closeModal}
      >
        <div
          className="flex max-h-[min(90vh,calc(100dvh-2rem))] w-full max-w-xl flex-col overflow-hidden rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] text-[hsl(var(--foreground))] shadow-xl"
          role="dialog"
          aria-modal="true"
          aria-labelledby="legal-mentions-title"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex shrink-0 items-center justify-end border-b border-[hsl(var(--border))] bg-[hsl(var(--card))] px-3 py-2">
            <button
              type="button"
              onClick={closeModal}
              className="flex h-9 w-9 items-center justify-center rounded-lg text-[hsl(var(--muted-foreground))] transition hover:bg-[hsl(var(--background))] hover:text-[hsl(var(--foreground))]"
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </div>
          <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4 sm:px-6">
            <LegalMentionsContent />
          </div>
        </div>
      </div>
    ) : null;

  return (
    <LegalNoticesContext.Provider value={{ openLegalNotices }}>
      {children}
      {modal ? createPortal(modal, document.body) : null}
    </LegalNoticesContext.Provider>
  );
}
